import { mediaQuery, supports, selectOr, selectNest } from '../util/style-queries';
import backgroundImage from './images/gradient.png';
import panelBackgroundImage from './images/glass.png';

const primaryColour = '#000';
const secondaryColour = '#b49c1c';
const highlightColour = '#dab200'; // eslint-disable-line no-unused-vars
const primaryBackgroundColor = '#5d1a4d';
const pageBackgroundColor = '#2e0d26';

const breakpoints = {
  smallMobileMax: '347px',
  shortScreen: '400px',
  mobileMax: '480px',
  tabletMax: '768px',
  desktopMax: '1200px',
};

const base = 16;
const smallBase = 14;
const baseMultiple = (multiple, b = base) => `${(b * multiple).toFixed(0)}px`;

const media = {
  smallMobile: mediaQuery(`max-width: ${breakpoints.smallMobileMax}`),
  shortScreen: mediaQuery(`max-height: ${breakpoints.shortScreen}`),
  mobile: mediaQuery(`max-width: ${breakpoints.mobileMax}`),
  notMobile: mediaQuery(`min-width: ${breakpoints.mobileMax}`),
  tabletMax: mediaQuery(`max-width: ${breakpoints.tabletMax}`),
  desktop: mediaQuery(`min-width: ${breakpoints.tabletMax}`),
  largeDesktop: mediaQuery(`min-width: ${breakpoints.desktopMax}`)
}

const fontFamily = 'verdana,sans-serif';

export default {
  media: {
    ...media,
    grid: selectNest(supports('display: grid'), media.notMobile)
  },
  link: secondaryColour,
  highlight: secondaryColour,

  typography: {
    baseMultiple: x => baseMultiple(x, base),
    smallBaseMultiple: x => baseMultiple(x, smallBase),

    body: {
      fontFamily,
      fontSize: baseMultiple(1),
      lineHeight: baseMultiple(1.5),
      ...selectOr(media.smallMobile, media.shortScreen)({
        fontSize: baseMultiple(1, smallBase),
        lineHeight: baseMultiple(1.5, smallBase),
        fontWeight: '300',
      }),
    },
    heading: {
      fontFamily,
      fontSize: baseMultiple(1.1),
      lineHeight: baseMultiple(1.5),
      fontWeight: 'normal',
      ...selectOr(media.smallMobile, media.shortScreen)({
        fontSize: baseMultiple(1.1, smallBase),
        lineHeight: baseMultiple(1.6, smallBase),
        fontWeight: '400',
      }),
    },
    small: {
      fontFamily,
      fontSize: baseMultiple(0.8),
      lineHeight: baseMultiple(1),
      ...selectOr(media.smallMobile, media.shortScreen)({
        fontSize: baseMultiple(0.8, smallBase),
        lineHeight: baseMultiple(1, smallBase),
      }),
    }

  },

  page: {
    backgroundColor: primaryBackgroundColor,
    textColor: secondaryColour,
  },

  menu: {
    linkColor: secondaryColour,
    hoverColor: primaryColour,
    backgroundColor: primaryBackgroundColor,
  },

  app: {
    backgroundImage: backgroundImage,
    backgroundColor: pageBackgroundColor,
  },

  panel: {
    textColor: primaryColour,
    title: {
      textColor: primaryColour,
      backgroundColor: secondaryColour,
    },
    backgroundImage: panelBackgroundImage,
  },

  footer: {
    textColor: '#606060',
  },
};



// WEBPACK FOOTER //
// ./src/theme/index.js